export {default as dispatch} from "./dispatch.js";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3/node_modules/d3-drag/node_modules/d3-dispatch/src/index.js
// module id = 549
// module chunks = 0